import { useState } from "react";

export function useModal(visible = false) {
  const [isModalVisible, setModalState] = useState(visible);

  const openModal = () => {
    setModalState(true);
  };

  const closeModal = () => {
    setModalState(false);
  };

  return { isModalVisible, openModal, closeModal };
}
